import {createAsyncThunk} from "@reduxjs/toolkit";

import appService from "services/app";
import HomeService from "../../services/home";

export const getCategoryList = createAsyncThunk(
  "get/categories",
  async (data: any, {rejectWithValue, dispatch}) => {
    try {
      const response = await appService.fetchCategoryList();

      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getCountryList = createAsyncThunk(
  "get/countries",
  async (data: any, {rejectWithValue, dispatch}) => {
    try {
      const response = await appService.fetchCountryList();

      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
export const getHomeNotices = createAsyncThunk(
  "get/homeNotices",
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const response = await appService.getHomeNotices();
      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getLanguages = createAsyncThunk(
  "get/languages",
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const response = await appService.getLanguages();
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getTags = createAsyncThunk(
  "get/tags",
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const response = await HomeService.getLessonsTags();
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);


